export default __webpack_public_path__ + "static/settings-d4bf18254a71045e22929cf13ceee0b2.png";